<template lang="pug">
#app
  router-view
    div
      h1 404
      p Route Not Found
</template>

<script>
import { mapGetters } from 'vuex'
import Cache from './lib/cache'
const CURRENT_USER_CACHE_KEY = 'u'
const CACHE = new Cache(CURRENT_USER_CACHE_KEY)

export default {
  name: 'App',
  computed: {
    ...mapGetters(['getUser']),
    currentUser() {
      return this.$currentUser.entity
    },
    history() {
      return this.$routeHistory.getHistory().h
    },
  },
  async created() {
    this.login()
    await this.$noembed.getProviders()
  },
  methods: {
    login() {
      // TEMPORARY pretend like we are logged in
      CACHE.set(this.getUser(1))
    },
  },
}
</script>

<style lang="sass">
@import 'assets/sass/index'

// variables
body
  --base-color-h: 210
  --base-color-s: 29%
  --base-color-l: 24%
  --base-color: hsl(var(--base-color-h),var(--base-color-s),var(--base-color-l))

  --base-color-light: hsl(var(--base-color-h),calc(var(--base-color-s)/5),calc(var(--base-color-l)*3))

  --accent-color-h: 39
  --accent-color-s: 100%
  --accent-color-l: 50%
  --accent-color: hsl(var(--accent-color-h),var(--accent-color-s),var(--accent-color-l))
  --accent-color-alpha: hsla(var(--accent-color-h),var(--accent-color-s),var(--accent-color-l),.1)

  --error-color-h: 0
  --error-color-s: 100%
  --error-color-l: 50%
  --error-color: hsl(var(--error-color-h), var(--error-color-s), var(--error-color-l))

  --underline-effect-line-height: 3px

  --serif-fonts: Palatino, "Palatino Linotype", "Palatino LT STD", "Book Antiqua", Georgia, serif
  --sans-serif-fonts: 'Avenir', Helvetica, Arial, sans-serif

  --base-padding: 1rem
  --half-padding: .5rem
  --quarter-padding: .25rem
  --double-padding: 2rem

  // post-title
  --post-title-max-lines: 2
  --post-title-font-size: 3rem
  --post-subtitle-font-size: 1.75rem
  --post-title-line-height: 1.4

  // post-content
  --post-content-font-size: 1.4rem
  --post-content-line-height: 1.5

  // fieldset
  --input-fontsize: 1rem
  --input-lineheight: 1.25
  --input-padding-v: .25rem
  --input-padding-h: .75rem
  --label-fontsize: calc(1rem * .8)
  --placeholder-color: #afafaf

  // fieldset-input
  --input-border-color: #afafaf
</style>
